import React from 'react'
import ThemeProvider from 'src/theme/ThemeProvider'
import Layout from 'src/theme/Layout'
import NewPassword from 'src/features/auth/NewPassword'

export default () => (
  <ThemeProvider>
    <Layout>
      <NewPassword />
    </Layout>
  </ThemeProvider>
)
